import { configureStore } from '@reduxjs/toolkit';
import { persistCombineReducers } from 'redux-persist';
import {
	persistStore,
	FLUSH,
	REHYDRATE,
	PAUSE,
	PERSIST,
	PURGE,
	REGISTER,
  } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import userReducer from './slices/userSlice';
import gameReducer from './slices/gameSlice';
import logger from 'redux-logger'

const persistConfig = {
  key: 'root',
  storage: storage,
  stateReconciler: autoMergeLevel2,

};

const _persistedReducer = persistCombineReducers(
	persistConfig, 
	{
		gameData: gameReducer,
        userData: userReducer,
	}
);

export const store = configureStore({
  reducer: _persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
	serializableCheck: {
	  ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
	},
  }).concat(logger),
});

export const persistor = persistStore(store);